<template>
  <div class="global-loading-container">
    <hot-loading class="global-loading" ref="globalLoading">
    </hot-loading>
  </div>
</template>

<script>

export default {
  name: 'TheGlobalLoading',
};
</script>

<style lang="scss" scoped>
.global-loading-container {
  display: flex;
  align-self: center;
  padding-top: 30vh;
  flex-direction: column;
}

.global-loading {
  max-width: 800px;
  font-weight: 300;
  font-size: var(--text-4);
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/Layout/components/TheGlobalLoading.vue